// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"actions-panel_wrapper__1eEbh","container":"actions-panel_container__k9P1I","readOnly":"actions-panel_readOnly__3W4ar"};